import React, { useEffect } from 'react';
import './Stats.css';
import DialogContainer from './../DialogContainer';
import Button from '@material-ui/core/Button';
import Axios from 'axios';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import { mandatoryData, generateMandatoryDataField } from './../form/UserProperties.js';
import { filteringOptions, generateFilterOption } from './../form/FilterOption.js';
import authClient from '../auth/Auth';
import { generateNotificationItem } from './NotificationItem';
import { API, AppId } from '../constants/constants';
import LinearProgress from '@material-ui/core/LinearProgress';

const formData = {};

export default function Stats(props) {
    const [items, setItems] = React.useState([]);
    const [properties, setProperties] = React.useState([]);
    const [notifications, setNotifications] = React.useState([]);
    const [isLoading, setLoading] = React.useState(false);
    const [, setObjects] = React.useState(null);
    const addButtonRef = React.useRef();
    const [metaData, setMetaData] = React.useState({});
    const [clientId, setClientId] = React.useState(null);
    const [affiliateId, setAffiliateId] = React.useState(null);
    const [, setStaging] = React.useState(false);
    const notificationsRef = React.useRef();

    const addFilteringOption = (option) => {
        let currentlyOpenOptions = properties;
        currentlyOpenOptions.push(option);

        updatePropertiesState(currentlyOpenOptions);
    }

    const handleValueChange = (key, value) => {
        if (key === mandatoryData.clientId.name) {
            if (value && metaData[value.value]) {
                setClientId(value.value);
            } else {
                setClientId(null);
                delete formData[key];
            }
        }
        if (key === mandatoryData.affiliateId.name) {
            if (value && metaData[clientId] && metaData[clientId][value.value]) {
                setAffiliateId(value.value);
            } else {
                setAffiliateId(null);
                delete formData[key];
            }
        }

        formData[key] = value;
        let obj = {};
        obj[key] = value.value;
        setObjects(obj);
    }


    useEffect(() => {
        setStaging(props.isStaging);
        setMetaData({});
        setClientId(null);
        setAffiliateId(null);
        Axios.get(props.isStaging ? API.staging.clientMetadata : API.production.clientMetadata, {
            headers: { 'x-access-token': authClient.getIdToken() }
        })
            .then(response => {
                console.log(response.data);
                if (response && response.data && response.data.data) {
                    setMetaData(response.data.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
                // always executed
                console.log("call finished");
            });
    }, [props.isStaging]);

    const updatePropertiesState = (currentlyOpenOptions) => {
        let newItems = [];
        currentlyOpenOptions.forEach((item, index) => {
            newItems.push(generateFilterOption(item, handleValueChange, removeItem));
        });
        setProperties(currentlyOpenOptions);
        setItems(newItems);
    }

    function genDataToSend() {
        let dataToSend = {};
        for (var prop in formData) {
            if (formData[prop] && formData[prop].error) {
                alert("please fix errors above");
                return;
            }
            if (!formData[prop].value && formData[prop].value === '') {
                continue;
            }
            dataToSend[prop] = formData[prop].value;
        }
        return dataToSend;
    }

    const retrieveNotifications = () => {
        let dataToSend = genDataToSend();
        setLoading(true);
        Axios.get(props.isStaging ? API.staging.notification : API.production.notification, {
            params: dataToSend,
            headers: { 'x-access-token': authClient.getIdToken() }
        })
            .then(response => {
                console.log(response);
                onResponse(response.data.data);
            })
            .catch(function (error) {
                console.log(error);
                alert(JSON.stringify(error));
            })
            .then(function () {
                // always executed
                console.log("call finished");
                setLoading(false);
            });
    }

    const onResponse = (data) => {
        let newNotifications = [];
        data.forEach((notification, index) => {
            newNotifications.push(generateNotificationItem(notification, callback, repliesCallback));
        });
        setNotifications(newNotifications);
        window.scrollTo({ top: (notificationsRef.current.offsetTop - 70), behavior: 'smooth' });
    }

    const callback = (id) => {
        let dataToSend = genDataToSend();
        return Axios.get(props.isStaging ?
            API.staging.notificationMetrics(id) : API.production.notificationMetrics(id), {
            params: dataToSend,
            headers: { 'x-access-token': authClient.getIdToken() }
        });
    }

    const repliesCallback = (id) => {
        let dataToSend = genDataToSend();
        return Axios.get(props.isStaging ?
            API.staging.notificationReplies(id) : API.production.notificationReplies(id), {
            params: dataToSend,
            headers: { 'x-access-token': authClient.getIdToken() }
        });
    }

    function removeItem(item) {
        let currentlyOpenProperties = properties;
        var index = currentlyOpenProperties.indexOf(item);
        console.log(currentlyOpenProperties);
        currentlyOpenProperties.splice(index, 1);

        updatePropertiesState(currentlyOpenProperties);
        console.log(addButtonRef);
        addButtonRef.current.reAddItem(item);
    }

    return (
        <div className="Stats">
            <h1>Notifications stats</h1>
            <form id="form">
                <Grid container
                    spacing={3}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <Grid item xs={6}>
                        {generateMandatoryDataField(mandatoryData.clientId, Object.keys(metaData), handleValueChange)}
                        {clientId ? generateMandatoryDataField(mandatoryData.affiliateId, Object.keys(metaData[clientId]), handleValueChange) : null}
                        {affiliateId ? generateMandatoryDataField(mandatoryData.appId, metaData[clientId][affiliateId].map(id => AppId(id)), handleValueChange) : null}
                    </Grid>
                    <Grid item xs={6}>
                        <div className="Stats-buttons">
                            <DialogContainer
                                label="Filtering options"
                                callback={addFilteringOption}
                                ref={addButtonRef}
                                properties={filteringOptions}
                            />
                        </div>
                        <div className="Stats-buttons">
                            <Button variant="contained" color="primary" onClick={retrieveNotifications}>
                                <div>
                                    Retrieve Notifications
                                        {isLoading ? <LinearProgress /> : null}
                                </div>
                            </Button>
                        </div>
                    </Grid>
                    {items ? items : null}
                </Grid>
            </form>
            <Grid container
                spacing={3}
                ref={notificationsRef}
                direction="row"
                justify="center"
                alignItems="center">
                <Grid item xs={10}>
                    {notifications ? notifications : null}
                </Grid>
            </Grid>
        </div>
    );
}